import { createContext, useContext } from 'react';

export interface Toast {
  id: number;
  message: string;
  tone: 'info' | 'error';
}

export interface ToastContextValue {
  show: (message: string, tone?: Toast['tone']) => void;
}

export const ToastContext = createContext<ToastContextValue | null>(null);

/** Short confirmations ("Link copied") that disappear on their own. */
export function useToast(): ToastContextValue {
  const value = useContext(ToastContext);
  if (!value) throw new Error('useToast must be used inside <Toaster>');
  return value;
}
